import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../../../constants/calendarGrid'
import { EMPTY_LIST } from '../../../../constants/common'
import {
  CALENDAR_ITEM_KIND_TAG_PROPS,
  CALENDAR_LIST_SEPARATOR,
} from '../../Calendar.constants'

export function getCalendarKindLabel({ kind, t }) {
  return t(CALENDAR_ITEM_KIND_TAG_PROPS[kind].text)
}

export function getCalendarPeopleLabel(people) {
  return people.map(person => person.name).join(CALENDAR_LIST_SEPARATOR)
}

export function getCalendarPersonList(person) {
  return person ? [person] : EMPTY_LIST
}

// TODO: read the address from its CAL-01 §11.1 field once the spec lists it
// (TM-01-08).
export function getCalendarDetailsLabel({ people, request }) {
  return [getCalendarPeopleLabel(people), request.address]
    .filter(Boolean)
    .join(CALENDAR_GRID_LABEL_SEPARATOR)
}
